// src/App.jsx
import React, { useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import './index.css'
import SignUpPage from './pages/SignUp'
import SignInPage from './pages/SignIn'
import DashboardPage from './pages/Dashboard'
import CareerAssessmentPage from './pages/CareerAssessment'
import Assessmentspage from './pages/Assessments'
import CareerLearningPathPage from './pages/CareerLearningPath'
import CareerPathPage from './pages/CareerPath'
import CareerExplorerPage from './pages/CareerExplorer'
import LearningResourcesPage from './pages/LearningResources'
import GoalsPage from './pages/Goals'
import AchievementsPage from './pages/Achievements'
import AICompanionPage from './pages/AI-Companion'
import ProfilePage from './pages/Profile'
import SettingsPage from './pages/Settings'
import CurriculumPage from './pages/Curriculum'
import NotificationsPage from './pages/Notifications'
import SchoolDashboardPage from './pages/SchoolDashboard'
import StudentsManagementPage from './pages/StudentsManagement'
import StudentOverviewPage from './pages/StudentOverview'
import SchoolResourcesPage from './pages/SchoolResources'
import AssessmentManagementPage from './pages/AssessmentManagement'
import ClassManagementPage from './pages/ClassManagement'
import SubjectManagementPage from './pages/SubjectManagement'
import AdminManagementPage from './pages/AdminManagement'
import DataCenterPage from './pages/DataCenter'
import ReportCenterPage from './pages/ReportCenter'
import AnalyticsPage from './pages/Analytics'
import ClassOverviewPage from './pages/ClassOverview'
import SchoolSettingsPage from './pages/SchoolSettings'



import { AuthStore } from './hooks/stores/AuthStore'
import { useThemeStore } from './hooks/stores/themeStore' // Import theme store
import { FloatingHeroSelector } from './components/ui/ThemeSelector/FloatingHeroSelector' // Import selector

function App() {
  
  // Initialize auth state when app loads
  // useEffect(() => {
  //   const initializeAuth = async () => {
  //     try {
  //       console.log('Initializing auth state...')
  //       await AuthStore.getState().initialize()
  //       console.log('Auth initialization complete')
  //     } catch (error) {
  //       console.error('Failed to initialize auth:', error)
  //     }
  //   }
    
  //   initializeAuth()
  // }, [])
  
  // Initialize theme on app load
  // useEffect(() => {
  //   const { applyTheme, selectedHero } = useThemeStore.getState();
  //   applyTheme(selectedHero);
  // }, []);

  return (
    <Router>
      <div className="min-h-screen" style={{ backgroundColor: 'var(--theme-background)' }}>
        <Routes>
          <Route path="/" element={<SignUpPage />} />
          <Route path="/signin" element={<SignInPage />} />
          <Route path="/dashboard" element={<DashboardPage />} />
          <Route path="/career-assessment" element={<CareerAssessmentPage />} />
          <Route path="/assessments" element={<Assessmentspage />} />
          <Route path="/career-learning-path" element={<CareerLearningPathPage />} />
          <Route path="/career-path" element={<CareerPathPage />} />
          <Route path="/career-explorer" element={<CareerExplorerPage />} />
          <Route path="/learning-resources" element={<LearningResourcesPage />} />
          <Route path="/goals" element={<GoalsPage />} />
          <Route path="/achievements" element={<AchievementsPage />} />
          <Route path="/ai-companion" element={<AICompanionPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/curriculum" element={<CurriculumPage />} /> 
          <Route path="/notifications" element={<NotificationsPage />} />
          <Route path="/school-dashboard" element={<SchoolDashboardPage />} />
          <Route path="/students-management" element={<StudentsManagementPage />} />
          <Route path="/student-overview" element={<StudentOverviewPage />} />
          <Route path="/school-resources" element={<SchoolResourcesPage />} />
          <Route path="/assessment-management" element={<AssessmentManagementPage />} />
          <Route path="/class-management" element={<ClassManagementPage />} />
          <Route path="/subject-management" element={<SubjectManagementPage />} />
          <Route path="/admin-management" element={<AdminManagementPage />} />
          <Route path="/data-center" element={<DataCenterPage />} />
          <Route path="/reports-center" element={<ReportCenterPage />} />
          <Route path="/analytics" element={<AnalyticsPage  />} />
          <Route path="/class-overview" element={<ClassOverviewPage  />} />
          <Route path="/school-settings" element={<SchoolSettingsPage  />} />

        </Routes>
        
        {/* <FloatingHeroSelector /> */}
      </div>
    </Router>
  )
}

export default App